(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll ---- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-mp-reveal]:not(.mp-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = parseInt(e.target.getAttribute('data-mp-delay') || '0', 10);
        setTimeout(function () { e.target.classList.add('mp-in'); }, d);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Sticky header state ---- */
  function initHeader() {
    var h = document.querySelector('[data-mp-header]');
    if (!h) return;
    var onScroll = function () {
      h.classList.toggle('mp-header--stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile drawer ---- */
  function initDrawer() {
    var drawer = document.querySelector('[data-mp-drawer]');
    if (!drawer) return;
    var open = function () {
      drawer.classList.add('mp-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var f = drawer.querySelector('a, button');
      if (f) f.focus();
    };
    var close = function () {
      drawer.classList.remove('mp-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    document.querySelectorAll('[data-mp-drawer-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    drawer.querySelectorAll('[data-mp-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('mp-open')) close();
    });
  }

  /* ---- Header search toggle ---- */
  function initSearch() {
    var panel = document.querySelector('[data-mp-search-panel]');
    if (!panel) return;
    document.querySelectorAll('[data-mp-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var isOpen = panel.classList.toggle('mp-open');
        b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          var i = panel.querySelector('input');
          if (i) i.focus();
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') panel.classList.remove('mp-open');
    });
  }

  /* ---- Accordions (FAQ) ---- */
  function initAccordions(root) {
    (root || document).querySelectorAll('[data-mp-acc]').forEach(function (acc) {
      if (acc.dataset.mpAccReady === '1') return;
      acc.dataset.mpAccReady = '1';
      var items = acc.querySelectorAll('.mp-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.mp-faq__q');
        var panel = item.querySelector('.mp-faq__a');
        if (!btn || !panel) return;
        var setH = function (o) {
          panel.style.height = o ? panel.firstElementChild.offsetHeight + 'px' : '0px';
        };
        if (item.classList.contains('mp-open')) {
          requestAnimationFrame(function () { setH(true); });
          btn.setAttribute('aria-expanded', 'true');
        }
        btn.addEventListener('click', function () {
          var willOpen = !item.classList.contains('mp-open');
          if (acc.dataset.mpAcc === 'single') {
            items.forEach(function (o) {
              if (o === item) return;
              o.classList.remove('mp-open');
              var ob = o.querySelector('.mp-faq__q');
              var op = o.querySelector('.mp-faq__a');
              if (ob) ob.setAttribute('aria-expanded', 'false');
              if (op) op.style.height = '0px';
            });
          }
          item.classList.toggle('mp-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          setH(willOpen);
        });
        window.addEventListener('resize', function () {
          if (item.classList.contains('mp-open')) setH(true);
        });
      });
    });
  }

  function boot() {
    initHeader();
    initDrawer();
    initSearch();
    initAccordions();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initDrawer();
    initSearch();
    initAccordions(e.target);
    initReveal(e.target);
  });
})();
